import { useModalContext } from "components/modal";
import { Button } from "components/button";
import React from "react";
import { useTranslation } from 'react-i18next';

type Props = {
	onConfirm: () => void;
    confirmationMessage?: string;
    confirmButtonTextClassName?: string;
};

/**
 * @summary - This component is used to confirm a user's action within a Modal
 * 
 * @param {Props} props {onConfirm: () => void}
 * @returns {React.ReactNode}
 * @example setModal({
 *     label: "A label",
 *     component: <AreYouSureModal onConfirm={} />
 * })
 * @note - You can build your function into the Modal context's OnAfterClose trigger to run when "confirmed" is true
 * 
 */
export default function AreYouSureModal(props: Props) {
    const { t } = useTranslation();
    const tBase = "components.areYouSureModal";
    const tr = (key: string) => t(`${tBase}.${key}`);

    const { setModal } = useModalContext();
    const [confirmed, setConfirmed] = React.useState(false);

    return (
        <div>
            <h3 className="mb-4">{props.confirmationMessage || tr("Are you sure?")}</h3>
            <Button style={{ margin: '10px', float: 'left' }} onClick={() => setModal(undefined)}>{tr("Cancel")}</Button>
            <Button primary style={{ margin: '10px', float: 'right' }} onClick={() => { props.onConfirm(); setConfirmed(true); setModal(undefined) }}>{tr("Confirm")}</Button>
        </div>
        )
}